export default "__VITE_ASSET__A4$FlIN5__"